import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { RefuseExternalProviderPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const refuseExternalProviderPayment = createAsyncThunk<void, RefuseExternalProviderPaymentBody, { extra: Partial<Dependencies> }>(
  "externalProviderPayments/refuseExternalProviderPayment",
  async (body: RefuseExternalProviderPaymentBody, { extra: { adminRepository } }) => {
    return adminRepository!.refuseExternalProviderPayment(body);
  },
);

export const resetRefuseExternalProviderPayment = createAction("externalProviderPayments/resetRefuseExternalProviderPayment");
